import axiosClient from "../common/axios/axiosConfig";
import { userDTO } from "../common/dtos/userDTO";
import { ErrorToast } from "../common/toast/toast";

interface IResponse {
  clinica: { id_reseller: string };
  usuario: userDTO;
}

const validateUser = (): Promise<IResponse | void> => {
  const clearStorage = new URLSearchParams(window.location.search).get("ls") || "false";

  if( clearStorage === "true" ) {
    localStorage.clear();
    // remove ls params for URL
    const url = new URL(window.location.href);
    url.searchParams.delete("ls");
    window.history.replaceState({}, document.title, url.toString());
  }

  const userInfo = localStorage.getItem("user_info");

  if (userInfo) {
    const user: userDTO = JSON.parse(userInfo);
    return Promise.resolve({
      clinica: { id_reseller: user.id_reseller },
      usuario: user,
    });
  }

  return axiosClient
    .get<IResponse>("validate-user")
    .then((info) => {
      if (info.data?.usuario){
        const userWithReseller ={
          ...info.data.usuario,
          id_reseller: info.data?.clinica?.id_reseller ?? null
        }
        localStorage.setItem("user_info", JSON.stringify(userWithReseller));
      }

      return info.data;
    })
    .catch(() => {
      ErrorToast.fire({
        text: "Erro ao validar usuário! Será realizada uma nova tentativa...",
      });
    });
};

export default validateUser;
